import React from "react"
import PropTypes from "prop-types"

import { useQuery } from "react-query"
import { Box, styled, Typography } from "@material-ui/core"
import { getPalletBatches } from "@/http/miscellaneous/getPalletBatches"
import { Skeleton } from "@material-ui/lab"
import { PalletBatch } from "./PalletBatch"

const StyledContainer = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(1, 1fr)",
  gap: "1rem",

  [theme.breakpoints.up("sm")]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },

  [theme.breakpoints.up("md")]: {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
}))

export function PalletBatchOutletList({ currentProduct, selected, onSelect }) {
  const { data, isLoading } = useQuery(
    ["pallet-batches", currentProduct?.cod_produto],
    () => getPalletBatches({ productId: currentProduct?.cod_produto }),
    {
      enabled: !!currentProduct?.cod_produto,
      staleTime: 1000 * 1, // 1 min
    }
  )

  const dataEmpty = !data || data.length === 0

  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap="1rem"
      position="relative"
    >
      <Typography>Pontas encontrados</Typography>

      <StyledContainer>
        {dataEmpty && (
          <Box gridColumn="span 4">
            <Typography color="textSecondary">
              {currentProduct
                ? "Nenhuma ponta encontrada, para esse produto"
                : "Selecione um produto, para buscar as pontas."}
            </Typography>
          </Box>
        )}

        {!dataEmpty &&
          !isLoading &&
          data.map((palletBatch) => {
            const id = palletBatch.id.toString()
            const isSelected = selected.includes(id)

            return (
              <PalletBatch
                key={id}
                data={palletBatch}
                selected={isSelected}
                onClick={() => onSelect({ ...palletBatch, id })}
              />
            )
          })}

        {isLoading && (
          <>
            <Skeleton variant="rect" height={30} style={{ borderRadius: 3 }} />
            <Skeleton variant="rect" height={30} style={{ borderRadius: 3 }} />
            <Skeleton variant="rect" height={30} style={{ borderRadius: 3 }} />
            <Skeleton variant="rect" height={30} style={{ borderRadius: 3 }} />
          </>
        )}
      </StyledContainer>
    </Box>
  )
}

PalletBatchOutletList.propTypes = {
  disabled: PropTypes.bool,
  currentProduct: PropTypes.object,
  selected: PropTypes.array,
  onSelect: PropTypes.func,
}

PalletBatchOutletList.defaultProps = {
  disabled: false,
  selected: [],
}
